import React from 'react';
import {Container} from "react-bootstrap";
import Projectlist from "../components/books";
import { Helmet } from 'react-helmet-async';
import logoimg from "../img/square.png";

function Home() {
    return (
        <div>
            <Helmet>
                <title>World by Mau</title>
                <meta property="og:title" content="World By Mau" />
                <meta property="og:image" content={logoimg} />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="World By Mau" />
                <meta name="twitter:image" content={logoimg} />
            </Helmet>
            <Container className="me-auto pb-5 mt-5">
                <Projectlist />
            </Container>
        </div>
    );
}

export default Home;
